//路由配置
import { createBrowserHistory } from "history";
export default createBrowserHistory();